<template>
  <div>
    <CCard class="sd_card">
      <CCardBody class="p-4 card-body">
        <div v-if="topForm">
          <CAlert show color="info">
            パスワード更新を行う場合は、下記のボタンを押してください。
            <br />本システムからパスワード更新について、ご案内メールが送信されます。
            <br />ご案内メールの記載内容に従って、パスワード更新を行ってください。
          </CAlert>
          <CButton
            class="info-button shadow-sm p-center"
            v-on:click="submitUpdatePassword('パスワード更新')"
          >
            <i class="icon cil-lock-locked"></i> パスワード更新
          </CButton>
        </div>
        <div v-if="ConfirmModal">
          <CAlert show color="success"
            ><p>登録されたEメールアドレスにパスワード更新のリンクを送信しました。</p></CAlert
          >
        </div>
      </CCardBody>
    </CCard>


    <CModal
      color="danger"
      closeOnBackdrop
      :centered="true"
      :show.sync="errorModal"
    >
      <p>{{ errorMessage }}</p>
      <template #header>
        <h4 class="modal-title">Error</h4>
      </template>
      <template #footer>
        <CButton @click="errorModal = false" color="secondary">
          <i class="icon cil-x"></i> 閉じる
        </CButton>
      </template>
    </CModal>
     
  </div>
</template>

<script>
// import Vue from 'vue'
import axios from "axios";

export default {
  name: "アプリ会員情報",
  data() {
    return {
       
      topForm: true,
      newEmail: "",
      ModalTitle: "",
      errorMessage: "",
      editingModal: false,
      ConfirmModal: false,
      successModal: false,
      errorModal: false,
    };
  },

  methods: {
    // update password post
    submitUpdatePassword: function (title) {
      this.ModalTitle = title;
      var userInfo = {
        username: this.$keycloak.userName,
        password: "",
      };
      // Confirm current password & update password.
      var urlRequest = "/rest/users/" + this.$keycloak.userName + "/password";
      axios
        .post(urlRequest, userInfo, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log(resp);
          this.topForm = false;
          this.ConfirmModal = true;
        })
        .catch((err) => {
           

          this.errorMessage = err;
          this.errorModal = true;
          // alert("パスワード更新要求はエラーが発生しました：" + err);
        });
    },
    // put email updated
  },
};
</script>
<style lang="scss">
.sp_card {
  border: none;
}
.card {
  border: none;
  .card-body {
    .alert {
      font-size: 0.85rem;
    }
    .form-row {
      margin: 0 0 1rem;
    }
  }
}
.p-center {
  margin: 0 auto;
  display: table;
}
</style>